/**
 * @generated SignedSource<<5495a032b6c3b0653dfd69d986358685>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WidgetTeamScheduleRoutineOccasionListItem_item$data = {
  readonly id: string;
  readonly routine: {
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"WidgetTeamScheduleRoutineListItemContent_Routine">;
  };
  readonly sequenceNumber: number;
  readonly totalTaskExecutionCount: number | null;
  readonly " $fragmentSpreads": FragmentRefs<"RoutineOccasionStatusCircle_RoutineOccasion" | "WidgetTeamScheduleRoutineIssueIndicator_routineOccasion" | "WidgetTeamScheduleRoutineListItemContent_RoutineOccasion">;
  readonly " $fragmentType": "WidgetTeamScheduleRoutineOccasionListItem_item";
};
export type WidgetTeamScheduleRoutineOccasionListItem_item$key = {
  readonly " $data"?: WidgetTeamScheduleRoutineOccasionListItem_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"WidgetTeamScheduleRoutineOccasionListItem_item">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WidgetTeamScheduleRoutineOccasionListItem_item",
  "selections": [
    (v0/*: any*/),
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "RoutineOccasionStatusCircle_RoutineOccasion"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "WidgetTeamScheduleRoutineIssueIndicator_routineOccasion"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "WidgetTeamScheduleRoutineListItemContent_RoutineOccasion"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "totalTaskExecutionCount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "sequenceNumber",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Routine",
      "kind": "LinkedField",
      "name": "routine",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "WidgetTeamScheduleRoutineListItemContent_Routine"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "RoutineOccasion",
  "abstractKey": null
};
})();

(node as any).hash = "dda58792abae451a9709d12e60cf84b1";

export default node;
